<template>
  <div>
    <el-dialog
      ref="viewDialog"
      v-dialogDrag
      title="查看直播活动参与人员信息"
      :visible.sync="dialogVisible"
      class="abow_dialog h500_dialog"
      width="1100px"
      :before-close="modalClose"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      append-to-body
    >
      <el-form
        ref="dialogViewForm"
        :model="dialogViewForm"
        class="add-edit-view-form"
        @submit.native.prevent
      >
        <div class="modal-box">
          <h3 class="modal-title">
            直播活动参与人员信息
          </h3>
          <div class="modal-row-box">
            <el-row :gutter="10">
              <el-col :span="6">
                <el-form-item label="直播平台">
                  <el-radio-group
                    v-model="dialogViewForm.platform"
                    disabled
                  >
                    <el-radio :label="1">
                      有赞直播
                    </el-radio>
                  </el-radio-group>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="问卷名称">
                  <el-input
                    v-model="dialogViewForm.liveEventName"
                    disabled
                  />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="成长值">
                  <el-input
                    v-model="dialogViewForm.growthValue"
                    disabled
                  />
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="10">
              <el-col :span="6">
                <el-form-item label="参与用户ID">
                  <el-input
                    v-model="dialogViewForm.uid"
                    disabled
                  />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="昵称">
                  <el-input
                    v-model="dialogViewForm.nickname"
                    disabled
                  />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="绑定本香门店手机号">
                  <el-input
                    v-model="dialogViewForm.bxPhone"
                    disabled
                  />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="区域">
                  <el-input
                    v-model="dialogViewForm.area"
                    disabled
                  />
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="10">
              <el-col :span="6">
                <el-form-item label="直播观看时长">
                  <el-input
                    v-model="dialogViewForm.viewingDuration"
                    disabled
                  >
                    <template slot="suffix">
                      秒
                    </template>
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="回看时长">
                  <el-input
                    v-model="dialogViewForm.reviewDuration"
                    disabled
                  >
                    <template slot="suffix">
                      秒
                    </template>
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="停留时长">
                  <el-input
                    v-model="dialogViewForm.stayDuration"
                    disabled
                  >
                    <template slot="suffix">
                      秒
                    </template>
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="离开直播间时间">
                  <el-date-picker
                    v-model="dialogViewForm.liveLeaveTime"
                    type="datetime"
                    format="yyyy-MM-dd HH:mm:ss"
                    style="width: 100%;"
                    disabled
                  />
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="10">
              <el-col :span="6">
                <el-form-item label="所在市场">
                  <el-input
                    v-model="dialogViewForm.city"
                    disabled
                  />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="门店名称">
                  <el-input
                    v-model="dialogViewForm.storeName"
                    disabled
                  />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="专卖证号">
                  <el-input
                    v-model="dialogViewForm.certificateNo"
                    disabled
                  />
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="10">
              <el-col :span="6">
                <el-form-item label="成长值发放结果">
                  <el-input
                    v-model="dialogViewForm.grantResultValue"
                    disabled
                  />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="成长值发放时间">
                  <el-input
                    v-model="dialogViewForm.grantGrowthValueTime"
                    disabled
                  />
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="成长值未发放原因">
                  <el-input
                    v-model="dialogViewForm.noGrantReason"
                    disabled
                  />
                </el-form-item>
              </el-col>
            </el-row>
          </div>
        </div>
      </el-form>

      <div
        slot="footer"
        class="dialog-footer"
      >
        <el-button @click="modalClose">
          关闭
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
// dialog拖拽Mixin
import dialogDragMixin from '@/mixin/dialogDragMixin'
// 直播活动API
import { viewLiveStreamingEventDetailApi } from '@/api/v2/liveStreamingEventDetail'

export default {
  components: {},
  mixins: [dialogDragMixin],
  props: {
    dialogTitle: {
      type: String,
      default: ''
    },
    dialogVisible: {
      type: Boolean,
      default: false
    },
    dataId: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      dialogViewForm: {},
    }
  },
  watch: {
    dialogVisible (val) {
      if (val) {
        let _this = this;

        _this.dialogViewForm = {}
        _this.loadLiveStreamingEventDetailData()

        _this.$nextTick(() => {
          _this.$refs.dialogViewForm.clearValidate()
        })
      }
    }
  },
  methods: {
    // 加载数据
    loadLiveStreamingEventDetailData () {
      let _this = this;
      viewLiveStreamingEventDetailApi({ id: _this.dataId }).then((response) => {
        const { data } = response;
        _this.dialogViewForm = data;

      })
    },
    modalClose () {
      let _this = this;
      _this.$emit('update:dialogVisible', false)
    },
  }
}
</script>
<style lang="scss"  scoped>
</style>
